import { ChevronDown } from 'baseui/icon';
import {
  themedStyled,
  themedUseStyletron,
} from 'common/styles/styletron.theme';
import { MappedRoute } from 'hooks/use-search-menu';
import * as React from 'react';

import {
  BeforeBorder,
  ChevronContainer,
  Column,
  CollapsibleContainer,
  IconContainer,
  IconWrapper,
} from './styles';
import NavigationComponent from '../navigation-component';

interface Props {
  route: MappedRoute;
  depth: number;
  isOpen: boolean;
}

export default function CollapsibleComponent(props: Props) {
  const [, theme] = themedUseStyletron();
  const { route, depth } = props;
  const [isOpen, setOpen] = React.useState(props.isOpen || false);

  const color = React.useMemo(() => {
    return theme.colors.black;
  }, [theme.colors.black]);

  return (
    <BeforeBorder className={`${depth === 1 ? '' : 'before-border'}`}>
      <CollapsibleContainer>
        <IconContainer onClick={() => setOpen((prev) => !prev)}>
          <IconWrapper>
            {route?.leftIcon?.(color, 18)}
            {route?.leftIcon && <div style={{ marginRight: 12 }} />}
            <StyledSpan
              $style={{
                ...theme.typography.LabelSmall,
                color,
                flexGrow: 1,
              }}
            >
              {route.title}
            </StyledSpan>
            <div style={{ marginRight: 16 }} />
            <ChevronContainer
              style={{
                transform: `${isOpen ? 'rotate(0deg)' : 'rotate(-90deg)'}`,
              }}
            >
              <ChevronDown color={color} size={24} />
            </ChevronContainer>
          </IconWrapper>
        </IconContainer>
        <Column
          style={{
            // display: `${!isOpen ? "none" : "flex"}`,
            maxHeight: `${isOpen ? '100%' : '0'}`,
          }}
        >
          {route.subNav?.map((nav, idx) => (
            <NavigationComponent
              key={'subRoute-' + nav.title + idx.toString()}
              route={nav}
              depth={depth + 1}
              isOpen={props.isOpen || false}
            />
          ))}
        </Column>
      </CollapsibleContainer>
    </BeforeBorder>
  );
}

const StyledSpan = themedStyled('span', {
  paddingLeft: '12px',
});
